import React, { useRef, useEffect, useState } from 'react'
import classNames from 'classnames'

import Datepicker from '../../Datepicker/Datepicker'

const RenderDateField = (props) => {

  let cursorRef: any = useRef({})

  const onChangeDate = (selectedDate) => {
    const newSelectedDate = selectedDate.split(" ").join("-")
    const value = [{ label: newSelectedDate, value: newSelectedDate }]
    const updatedCurrentQuery = { ...props.query, value, valueError: false }
    props.updateAdvancedQueryArray({
      currentQuery: updatedCurrentQuery,
      queryArray: props.queryArray,
      currentQueryIndex: queryIndex,
      action: 'updateQueryArray',
      queryObject: props.queryObj,
      parentQueryObject: props.parentQueryObject
    })
    props.closeAutoComplete()
  }

  const { queryObj, queryObjIndex, queryIndex, type, activeSuggestionIndex } = props
  const isAutoCompleteOpen = `${queryObj.cursorY}-${queryObjIndex}-${queryIndex}-${type}` === activeSuggestionIndex
  const { value = [] } = props.query

  let styleObj: any = { position: 'absolute', background: '#fff', zIndex: 12, top: '41px', left: 0 }


  const handleKeyBindings = (e) => {
    const { key } = e
    if (!props.isVisible) return

    if (key === 'Enter' && props.isValueActive) {
      cursorRef.current.click()
    }
    if (key === 'Escape' && isAutoCompleteOpen) {
      props.closeAutoComplete()
    }
  }

  useEffect(() => {
    document.addEventListener('keyup', handleKeyBindings, false)

    return () => {
      document.removeEventListener('keyup', handleKeyBindings, false)
    }
  }, [props.isValueActive, isAutoCompleteOpen, cursorRef, props.isVisible])

  return (
    <div
      data-test-id="cs-advance-search-select-value"
      className={classNames(
        'query-value',
        props.type === 'key' && 'query-key-label',
        props.query.valueError && 'query-value-error',
        props.placeholderClass,
        props.isValueActive && 'query-value-active'
      )}
      onClick={(e) => {
        props.openAutoComplete(e, props.type)
      }}
      ref={cursorRef}>
      <div className="query-value-textTruncate">{value[0]?.label || 'mm-dd-yyyy'}</div>
      {isAutoCompleteOpen && (
        <div style={styleObj}>
          <Datepicker
            testId="cs-advance-search-date-field"
            version="v2"
            inputMaskProps={{ hasInputMask: false }}
            formatType="mm dd yyyy"
            withFooter={true}
            withCurrentDate={false}
            onChange={onChangeDate}
            initialDate={new Date()}
            onCancelClick={props.closeAutoComplete}
            closeOnOverlayClick={true}
          />
        </div>
      )}
    </div>
  )
}

export default RenderDateField
